<template>
  <div class="footer">
    <div class="rodape">
      <div class="centro">
        <div class="top-row">
          <div class="coluna-rodape">
            <h2>Conheça Outros Projetos</h2>
            <div class="grupo">
              <div class="logos">
                <a href="https://revisa.go.gov.br/" target="blank">
                  <img src="../assets/images/logo_revisa.png" class="Logo-revisa" alt="Logo do Revisa Goiás" title="Acesse o Revisa Goiás" />
                </a>
                <a href="https://tanalei.casacivil.go.gov.br" target="blank">
                  <img src="../assets/images/logo_tanalei.png" class="logo-tanalei" alt="logo do Ta Na Lei" title="Acesse o Tá Na Lei e fique por dentro dos seus direitos" />
                </a>
              </div>
            </div>
          </div>

          <div class="coluna-rodape">
            <h2>Serviços</h2>
            <div class="grupo">
              <router-link :to="{name: 'PesquisaLegislacao'}" target="blank" class="link-footer">Pesquise a legislação</router-link>
              <a href="https://www.casacivil.go.gov.br/files/institucional/cadastro-de-autoridades-2022.pdf" target="blank" class="link-footer">Cadastro de autoridades</a>
              <a href="https://diariooficial.abc.go.gov.br/" target="blank" class="link-footer">Diário Oficial do <br /> Estado de Goiás</a>
            </div>
          </div>

          <div class="coluna-rodape">
            <h2>Redes Sociais</h2>
            <div class="grupo-social">
              <a href="https://www.facebook.com/casacivilgoias/" target="blank" alt="Link para a página do facebook da Casa Civíl" title="Facebook da Casa Civíl" class="face">
                <img src="../assets/images/logo_face_verde.svg" class="logo-face-verde" />
                <img src="../assets/images/logo_face_color.svg" class="logo-face-color" />
              </a>
              <a href="https://www.instagram.com/casacivilgoias/?hl=pt-br" target="blank" title="Instagram da Casa Civíl" alt="Link para a página do Instagram da Casa Civíl" class="insta">
                <img src="../assets/images/logo_insta_verde.svg" class="logo-insta-verde" />
                <img src="../assets/images/logo_insta_color.svg" class="logo-insta-color" />
              </a>
              <a href="https://x.com/casacivilgoias" target="blank" title="X da Casa Civil" alt="Link para a página do X da Casa Civíl" class="x">
                <img src="../assets/images/logo_x_verde.svg" class="logo-x-verde" />
                <img src="../assets/images/logo_x_color.svg" class="logo-x-color" />
              </a>
            </div>
          </div>

          <div class="coluna-rodape">
            <h2>Ouvidoria e Transparência</h2>
            <div class="grupo">
              <a href="http://www.transparencia.go.gov.br/portaldatransparencia/" target="blank" class="link-footer">Goiás Transparência</a>
              <a href="http://www.cge.go.gov.br/ouvidoria/" target="blank" class="link-footer">Ouvidoria Geral do Estado</a>
              <a href="https://vaptvupt.go.gov.br/servicos" target="blank" class="link-footer">Serviço de Informação<br /> ao Cidadão - SIC</a>
              <a href="http://www.cge.go.gov.br/ouvidoria/Register_1.php" target="blank" class="link-footer">Serviço Eletrônico de<br /> Informação ao cidadão - e-SIC</a>
            </div>
          </div>
        </div>
        <div class="bottom-row">
          <img src="../assets/images/logo_transparencia.png" class="logo-transparencia" alt="logo do Goias Transparente" />
          <span>v{{ version }}</span>
          <a href="https://casacivil.go.gov.br">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
  .rodape {
    background-color: #115810;
    color: #fff;

    .centro {
      display: flex;
      flex-direction: column;
      gap: 2rem;
      padding: 2rem;

      .top-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        margin: 0 auto;
        align-items: flex-start; /* Alinha as colunas pelo topo */
        gap: 1rem; /* Adiciona um espaço caso as colunas quebrem de linha */
      }
      
      .coluna-rodape {
        display: flex;
        font-family: 'Poppins';
        flex-direction: column;
        align-items: center; /* Centraliza o conteúdo da coluna */
        flex: 1; /* Permite que as colunas cresçam igualmente */
        min-width: 200px; /* Largura mínima para evitar que fiquem muito espremidas */

        h2 {
          background-color: #ffb24e;
          color: #0e489f;
          font-size: 16.6px;
          font-family: 'Poppins-bold';
          font-weight: 700;
          text-transform: uppercase;
          padding: 0.3rem 1rem;
          border-radius: 4px;
          margin-bottom: 1rem; /* Espaço entre o título e o conteúdo */
          width: 100%; /* Faz o fundo amarelo ocupar toda a largura da coluna */
          text-align: center;
        }
      }

      .bottom-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.9rem;
        color: #fff;
      }
      .logo-transparencia {
        max-width: 125px;
        height: left;
        
      }
    }
  }

  .grupo {
    display: flex;
    font-size: 13.3px;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center; /* Garante que os links e logos fiquem centralizados */
    
    .link-footer {
      text-decoration: none;
      color: #fff;
      transition: 0.3s;
      text-align: center;
    }

    .link-footer:hover {
      text-decoration: underline;
      color: #FFB24E;
    }
    
    .logos {
      display: flex;
      flex-direction: column;
      align-items: center; /* Centraliza os logos */
      gap: 0rem;

            img {
              max-width: 100%; /* Reduced width */
              height: 50px; /* Fixed height for cropping */
              object-fit: cover; /* Crop top/bottom if image is taller than height */
              transition: transform 0.3s ease;
            }
      img:hover {
        transform: scale(1.05);
      }
    }
  }

  .coluna-rodape:first-child .grupo,
  .coluna-rodape:first-child .logos {
      align-items: flex-start;
  }
  
  .grupo-social {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  a {
    display: flex;
    align-items: center;

    img {
      height: 25px;       /* altura desejada */
      object-fit: contain; /* garante que não estoure */
      transition: opacity 0.3s ease;
    }

    /* ícones coloridos escondidos e do mesmo tamanho da verde */
    .logo-face-color,
    .logo-insta-color,
    .logo-x-color {
      display: none;
    }
  }
  

  .face:hover .logo-face-color,
  .insta:hover .logo-insta-color,
  .x:hover .logo-x-color {
    display: inline;
  }

  .face:hover .logo-face-verde,
  .insta:hover .logo-insta-verde,
  .x:hover .logo-x-verde {
    display: none;
  }
}


}

/* Responsividade - telas menores */
@media screen and (max-width: 992px) { /* Ajustado para um breakpoint maior */
  .footer .rodape .centro .top-row {
      flex-direction: column;
      align-items: center;
      text-align: center;
  }
  .footer .grupo-social {
    flex-direction: row;
  }
  .footer .coluna-rodape {
      width: 100%;
      max-width: 400px;
  }
}

@media screen and (max-width: 768px) {
  .footer .grupo .logos img {
    max-width: 100%;
  }
  .footer .grupo-social {
    flex-direction: row;
  }
}

/* Alto contraste */
.alto-contraste {
  .rodape {
    background-color: #115810;
  }
}
</style>
